import React from 'react';
import Area from '@splunk/dashboard-visualizations/Area';

export default () => (
    <Area
        options={{
            'chart.nullValueMode': 'zero',
        }}
        encoding={{
            x: 'primary._time',
            y: ['primary[1]', 'primary[2]'],
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [
                        {
                            name: '_time',
                            groupby_rank: '0',
                        },
                        {
                            name: '10.1.1.000',
                            data_source: 'sum(date_hour)',
                            splitby_field: 'clientip',
                            splitby_value: '10.1.1.000',
                        },
                        {
                            name: '10.1.1.002',
                            data_source: 'sum(date_hour)',
                            splitby_field: 'clientip',
                            splitby_value: '10.1.1.002',
                        },
                        {
                            name: '_span',
                        },
                    ],
                    columns: [
                        [
                            '2017-08-20T00:00:00.000-07:00',
                            '2017-08-20T00:30:00.000-07:00',
                            '2017-08-20T01:00:00.000-07:00',
                            '2017-08-20T01:30:00.000-07:00',
                            '2017-08-20T02:00:00.000-07:00',
                            '2017-08-20T02:30:00.000-07:00',
                            '2017-08-20T03:00:00.000-07:00',
                            '2017-08-20T03:30:00.000-07:00',
                            '2017-08-20T04:00:00.000-07:00',
                            '2017-08-20T04:30:00.000-07:00',
                        ],
                        ['', '', '170', '100', '22', '', '', '1040', '221', '42'],
                        ['', '', '', '', '460', '154', '', '36', '576', '1625'],
                        ['1800', '1800', '1800', '1800', '1800', '1800', '1800', '1800', '1800', '1800'],
                    ],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
